import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms'

import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { DevoteeDetail } from "./../Devotee/devotee-detail";


@Injectable()
export class SharedService {

  constructor(private spinnerService: Ng4LoadingSpinnerService) { }

  public static get BaseServiceUrl(): string {
    //  return "http://localhost:64244/api/";
    // return "http://localhost:5200/api/"
    // return "https://localhost:44314/api/"
    //return "https://pujaprasad.in/vir_service/api/";
    //return "https://localhost:7108/api/";
    // return "https://testapi.pujaprasad.in/api/";
    return "https://mobileapi.pujaprasad.in/api/";
  }

  public static get BaseMobileServiceUrl(): string {
    // return "https://localhost:7108/api/";
    // return "http://localhost:5200/api/"
    // return "https://localhost:44314/api/"
    // return "https://mobileapi.pujaprasad.in/api/";
    return "";
  }


  private _IsDevoteeLogin: boolean = false;
  public get IsDevoteeLogin(): boolean {
    return this._IsDevoteeLogin;
  }

  private _IsAdminLogin: boolean = false;
  public get IsAdminLogin(): boolean {
    return this._IsAdminLogin;
  }

  // showAdminApp property
  public static get showAdminApp(): boolean {
    return true;
  }

  showSpinner() {
    this.spinnerService.show();
  }

  hideSpinner() {
    this.spinnerService.hide();
  }

  setTokenDataAtLocStorage(token: string): void {
    localStorage.setItem("UserToken", token);
  }

  getTokenDataAtLocStorage(): string {
    return localStorage.getItem("UserToken");
  }

  removeTokenDataAtLocStorage(): void {
    localStorage.removeItem("UserToken");
    this._IsDevoteeLogin = false;
  }

  setDevoteeDataAtLocStorage(devotee: DevoteeDetail): void {
    localStorage.setItem("DevoteeData", JSON.stringify(devotee));
    this._IsDevoteeLogin = true;
  }

  getDevoteeDataAtLocStorage(): DevoteeDetail {
    let devotee = (JSON.parse(localStorage.getItem("DevoteeData")) as DevoteeDetail);
    this._IsDevoteeLogin = (devotee != null);
    return devotee;
  }

  removeDevoteeDataAtLocStorage(): void {
    localStorage.removeItem("DevoteeData");
    this._IsDevoteeLogin = false;
  }

  setAdminTokenAtLocStorage(tokenNo: string): void {
    localStorage.setItem("AdminToken", tokenNo);
    this._IsAdminLogin = true;
  }

  getAdminTokenAtLocStorage(): string {
    let adminToken = localStorage.getItem("AdminToken");
    this._IsAdminLogin = (adminToken != null);
    console.log(this.IsAdminLogin);
    return adminToken;
  }

  removeAdminTokenAtLocStorage(): void {
    localStorage.removeItem("AdminToken");
    this._IsAdminLogin = false;
  }

  setDevoteeCartDataAtLocStorage(cartData: any): void {
    localStorage.setItem("CartData", JSON.stringify(cartData));
  }

  getDevoteeCartDataAtLocStorage(): any {
    var cartData = JSON.parse(localStorage.getItem("CartData"));
    return cartData ? cartData : [];
  }

  public validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  // State list Property 
  public get StateLists(): string[] {
    return this._stateLists;
  }


  private _stateLists: string[] = [
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chhattisgarh",
    "Chandigarh",
    "Dadra and Nagar Haveli",
    "Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Orissa",
    "Punjab",
    "Pondicherry",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal"
  ]

}



// WEBPACK FOOTER //
// ./src/app/shared/shared.service.ts